module.exports = __webpack_public_path__ + "img/hanfu-1.5ffc69df.jpg";